<template>
    <BreadCrumb PageTitle="Modifier une boîte postale" />
    <EditBoitePostale />
</template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditBoitePostale from "../../components/BoitePostale/EditBoitePostale.vue";
  
    export default defineComponent({
      name: "EditBoitePostalePage",
      components: {
        BreadCrumb,
        EditBoitePostale,
      },
    });
  </script>